import { Required } from '@decorators/entity-required.decorator';
import { Primary } from '@decorators/entity-primary.decorator';
import { KeepProperty } from '@decorators/entity-keepproperty.decorator';


import { Dommage } from './dommage.class';

export class TdgPiece {
	@Required
	@Primary
	id: number;

	@Required
	label: string;

	prefix: string;

	isActive: boolean;

	@KeepProperty
	dommages: Dommage[];
}
